import React from "react";

const About = () => {
    return (
        <section className="About">
            <div className="container">
                <div className="grid col-2 column-gap mobile-column">
                    <p className="section-title">What I Build</p>
                    <div className="text-group">
                        <p>I build software that helps people work, create, and grow their businesses. My experience spans web applications, mobile apps, ecommerce platforms, APIs, automation tools, and custom business systems. From concept to deployment, I enjoy solving technical problems and turning ideas into products people can use.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;